/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { SizeMe } from "react-sizeme"
import { Document, Page } from "react-pdf/dist/esm/entry.webpack"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"

import Container from "../components/container"
import Layout from "../components/layout"
import file from "../data/Vidhi__Mody_Full_Time_Resume.pdf"

class Resume extends React.Component {
  constructor() {
    super()
    this.state = {
      numPages: null,
      pageNumber: 1,
    }

    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this)
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({ numPages })
  }

  render() {
    const { pageNumber } = this.state

    return (
      <Layout location={this.props.location}>
        <Container>
          <SizeMe
            monitorHeight
            refreshRate={128}
            refreshMode={`debounce`}
            render={({ size }) => (
              <div>
                <button
                  sx={{
                    my: 3,
                  }}
                >
                  <a href={file} download="Vidhi_Resume">
                    Download
                  </a>
                </button>
                <Document
                  file={file}
                  renderMode="svg"
                  onLoadSuccess={this.onDocumentLoadSuccess}
                >
                  <Page width={size.width} pageNumber={pageNumber} />
                </Document>
              </div>
            )}
          ></SizeMe>
        </Container>
      </Layout>
    )
  }
}

export default Resume
